import { makeStyles } from '@material-ui/core/styles';

export const useStylesTabs = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    minHeight: 0,
    marginBottom: '1rem',
    backgroundColor: theme.colors.dark.darkSlateGray,
    '& .MuiTab-textColorInherit.Mui-selected': {
      border: `2px solid ${theme.colors.orange.orangered}`,
    },
  },
  indicator: {
    backgroundColor: 'transparent',
  },
}));

export const useStylesTab = makeStyles(theme => ({
  root: {
    minWidth: 100,
    minHeight: 0,
    height: 33,
    margin: '0px 5px',
    fontSize: 14,
    textTransform: 'none',
    color: theme.colors.orange.peru,
    whiteSpace: 'nowrap',
    borderRadius: 50,
    background: theme.colors.orange.orangeSemiTransparent,
    '& .MuiChip-label': {
      fontSize: theme.fonts.sizes.font12PX,
      color: theme.colors.orange.orange,
    },
  },
}));
